import { useState } from 'react'
import WhatsAppLink from './WhatsAppLink'

interface NavbarProps {
  isScrolled: boolean
}

const Navbar = ({ isScrolled }: NavbarProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      const offsetTop = element.offsetTop - 80
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      })
    }
    setIsMenuOpen(false)
  }

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-white shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <a
              href="#inicio"
              onClick={(e) => {
                e.preventDefault()
                scrollToSection('inicio')
              }}
              className="flex items-center"
            >
              <img
                src="/default/artcustom.png"
                alt="Art Custom Logo"
                className="h-12 w-auto"
              />
            </a>
            <span className={`text-sm transition-colors duration-500 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              <strong>Art Custom</strong>
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {['inicio', 'sobre', 'produtos'].map((id) => (
              <a
                key={id}
                href={`#${id}`}
                onClick={(e) => {
                  e.preventDefault()
                  scrollToSection(id)
                }}
                className={`font-medium transition-colors duration-500 ${
                  isScrolled
                    ? 'text-gray-700 hover:text-[#0877c5]'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {id === 'inicio' ? 'Início' : id === 'sobre' ? 'Sobre' : 'Produtos'}
              </a>
            ))}
            <WhatsAppLink
              className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                isScrolled
                  ? 'bg-gradient-to-r from-[#0877c5] to-[#b51625] text-white hover:shadow-lg'
                  : 'bg-white/15 backdrop-blur-sm text-white border border-white/30 hover:bg-white/25'
              }`}
            >
              Orçar Agora
            </WhatsAppLink>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`md:hidden p-2 rounded-md transition-colors duration-500 ${isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg
              className="h-6 w-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className={`md:hidden py-4 space-y-4 ${isScrolled ? 'bg-white' : 'bg-gray-900/90 backdrop-blur-md rounded-b-2xl'}`}>
            {['inicio', 'sobre', 'produtos'].map((id) => (
              <a
                key={id}
                href={`#${id}`}
                onClick={(e) => {
                  e.preventDefault()
                  scrollToSection(id)
                }}
                className={`block font-medium transition-colors px-2 ${
                  isScrolled ? 'text-gray-700 hover:text-[#0877c5]' : 'text-white/90 hover:text-white'
                }`}
              >
                {id === 'inicio' ? 'Início' : id === 'sobre' ? 'Sobre' : 'Produtos'}
              </a>
            ))}
            <WhatsAppLink
              className="block w-full bg-gradient-to-r from-[#0877c5] to-[#b51625] text-white px-6 py-2 rounded-full text-center font-medium"
              onClick={() => setIsMenuOpen(false)}
            >
              Orçar Agora
            </WhatsAppLink>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar

